import Box from '@mui/material/Box'

import termsOfService from 'bundle-text:./TermsOfService.text'

export default function TermsOfService(){
  return <Box component="p" sx={{whiteSpace: 'pre-wrap'}}>{termsOfService}</Box>
}
